<script setup lang="ts">
import { useRoute } from "vue-router";

// 路由
const router = useRoute();

location.href = `weixin://dl/business/?appid=${router.query.appid}&path=${router.query.path}&env_version=${router.query.env_version ?? "release"}&query=${router.query.query}`;
</script>

<template>
  <div>正在打开小程序...</div>
</template>

<style scoped lang="less"></style>
